import React, { useState } from 'react';
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Button,
  Typography,
  FormHelperText,
} from '@mui/material';

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const WorkPreferencesForm = ({ onChildData }) => {
  const [workPreferences, setWorkPreferences] = useState({
    remote_work: '',
    in_person_work: '',
    open_to_relocation: '',
    willing_to_complete_assessments: '',
    willing_to_undergo_drug_tests: '',
    willing_to_undergo_background_checks: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setWorkPreferences({ ...workPreferences, [name]: value });
    onChildData({work_preferences:{ ...workPreferences, [name]: value}});
    setErrors({ ...errors, [name]: false }); // Clear error when user makes a selection
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    // Check for empty fields
    for (const key in workPreferences) {
      if (workPreferences[key] === '') {
        newErrors[key] = true; // Set error for empty fields
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors); // Set errors state
      return; // Prevent form submission
    }

    // Format output
    const output = `work_preferences:\n  remote_work: "${workPreferences.remote_work}"\n  in_person_work: "${workPreferences.in_person_work}"\n  open_to_relocation: "${workPreferences.open_to_relocation}"\n  willing_to_complete_assessments: "${workPreferences.willing_to_complete_assessments}"\n  willing_to_undergo_drug_tests: "${workPreferences.willing_to_undergo_drug_tests}"\n  willing_to_undergo_background_checks: "${workPreferences.willing_to_undergo_background_checks}"`;

    console.log(output);
    // Process work preferences as needed
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3, pt: 0, pb: 2 }}>
      <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="h6">Work Preferences</Typography>
          </AccordionSummary>
          <AccordionDetails>
          
      <FormControl required error={errors.remote_work} sx={{ mb: 2, display: 'block' }}>
        <Typography variant="body2">Open to Remote Work?</Typography>
        <RadioGroup
          name="remote_work"
          value={workPreferences.remote_work}
          onChange={handleChange}
          row
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
        {errors.remote_work && <FormHelperText>This field is required.</FormHelperText>}
      </FormControl>

      <FormControl required error={errors.in_person_work} sx={{ mb: 2, display: 'block' }}>
        <Typography variant="body2">Open to In-Person Work?</Typography>
        <RadioGroup
          name="in_person_work"
          value={workPreferences.in_person_work}
          onChange={handleChange}
          row
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
        {errors.in_person_work && <FormHelperText>This field is required.</FormHelperText>}
      </FormControl>

      <FormControl required error={errors.open_to_relocation} sx={{ mb: 2, display: 'block' }}>
        <Typography variant="body2">Open to Relocation?</Typography>
        <RadioGroup
          name="open_to_relocation"
          value={workPreferences.open_to_relocation}
          onChange={handleChange}
          row
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
        {errors.open_to_relocation && <FormHelperText>This field is required.</FormHelperText>}
      </FormControl>

      <FormControl required error={errors.willing_to_complete_assessments} sx={{ mb: 2, display: 'block' }}>
        <Typography variant="body2">Willing to Complete Assessments?</Typography>
        <RadioGroup
          name="willing_to_complete_assessments"
          value={workPreferences.willing_to_complete_assessments}
          onChange={handleChange}
          row
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
        {errors.willing_to_complete_assessments && <FormHelperText>This field is required.</FormHelperText>}
      </FormControl>

      <FormControl required error={errors.willing_to_undergo_drug_tests} sx={{ mb: 2, display: 'block' }}>
        <Typography variant="body2">Willing to Undergo Drug Tests?</Typography>
        <RadioGroup
          name="willing_to_undergo_drug_tests"
          value={workPreferences.willing_to_undergo_drug_tests}
          onChange={handleChange}
          row
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
        {errors.willing_to_undergo_drug_tests && <FormHelperText>This field is required.</FormHelperText>}
      </FormControl>

      <FormControl required error={errors.willing_to_undergo_background_checks} sx={{ mb: 2, display: 'block' }}>
        <Typography variant="body2">Willing to Undergo Background Checks?</Typography>
        <RadioGroup
          name="willing_to_undergo_background_checks"
          value={workPreferences.willing_to_undergo_background_checks}
          onChange={handleChange}
          row
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
        {errors.willing_to_undergo_background_checks && <FormHelperText>This field is required.</FormHelperText>}
      </FormControl>
          </AccordionDetails>
        </Accordion>

      <Button type="submit" variant="contained" sx={{display:'none'}}>
        Submit
      </Button>
    </Box>
  );
};

export default WorkPreferencesForm;